import * as React from "react";
import "../Styles/style.css";

export default function TermsConditions() {
  return (
    <>
      <div className="infoMainConatiner py-5">
        <div className="container">
          <h4 className="termsMainHeading">Terms of Service</h4>

          <div className="infoMainBody p-3">
            <h5>Acknowledgment of Terms:</h5>
            <p>
              To access the FameWheels.com platform for the desired services, it
              is momentous to accept the terms and conditions outlined in this
              section, as they organise the sole foundation governing your
              interactions with the website and your use of the services. If any
              of the terms not align with your agreement, refrain from using the
              website or availing services from FameWheels.com.
              <br />
              <br />
              Your acknowledgment and affirmation that usage (defined below) of
              this online platform is under draconian rules and regulations and
              administration of the terms included in this Agreement.
            </p>
            <br />
            <h5>Introduction to Terms of Use:</h5>
            <p>
              Welcome to FameWheels, a company run by Fame Wheels Private
              Limited ("FameWheels," "we," "us," or "our"). We show our
              gratitude to invite you in order to explore FameWheels for the
              vehicle-based services, product information, forums, and more
              pertaining to cars.
              <br /> <br />
              The terms to use this electronic platform is established under the
              law and regulation of Pakistan, highlighting electronic documents.
              These mentioned terms do not require any electronic, physical, or
              digital signatures.
              <br />
              <br />
              The domain{" "}
              <a href="https://www.famewheels.com/">www.FameWheels.com </a> is
              solely associated with Fame Business Solution Private Limited. A
              company that is registered under the law of Pakistan with its
              physical location office on the 2nd Floor, The plaza shopping
              center, Clifton Block 9, Karachi. These terms of use apply to the
              website accessible at www.FameWheels.com, including the mobile
              website and mobile application (collectively referred to as the
              "Website"). These terms develop an agreement between main actors,
              FameWheels, Visitors, and Registered users of FameWheels of the
              Website, referred to as You, Yours, User, or Customers. They
              describe the terms and conditions for the users access the
              FameWheels website, and take advantage of our services and product
              purchases offered by FameWheels.Com.
              <br /> <br />
              These terms of service are effective as of 1st January 2021.
            </p>
            <br />
            <h5>Eligibility for Service Utilization:</h5>
            <p>
              The FameWheels website services are utterly intended for
              individuals who lie under the legal age (18 Years or older) and
              those who are legally competent to enter into a legal contract,
              under the Pakistan Contracts Act, 1872 (as modified) or any other
              relevant laws or rules.
              <br /> <br />
              Furthermore, individuals who are not enough capable for legal
              bidding and hold valid contracts due to some reasons, including
              being a minor, non-compos mentis, underwater, or any other causes
              are forbidden from the use of FameWheels services or entire
              platform. By retrieving the FameWheels online platform or engaging
              with us, you avow to us that you are legally capable and hold the
              authority to enter into our valid agreement under the user terms.
              <br /> <br />
              Moreover, FameWheels holds the right to terminate or restrict
              access of users at any time without providing any explanation. We
              also have the right to cut our access to you from our website,
              devices, services, or any other product related to us.
              <br />
              <br />
              Along with any other remedies available to FameWheels, this
              ability to suspend or terminate services is an extra precaution in
              the event that access to the website, use of our services, or
              violation of the terms of the applicable application, this
              Agreement, or any other applicable law occurs
            </p>
            <br />
            <h5>Important Notice:</h5>
            <p>
              FameWheels uses different means to provide a comprehensive
              platform, including a website, mobile-based application, and
              server as an online marketplace to allow users to take advantage
              of our services. Any needful information available on FameWheels
              platform is only for knowledge purposes and does not substitute
              specific advice whether related to taxation, legal matters,
              investments, or any other realm. Moreover, it is also important to
              note that this all not intended to provide any guarantee, warranty
              or certification. FameWheels assumes no responsibility and cannot
              be held accountable for transactions conducted between users of
              the website.
              <br /> <br />
              You acknowledge and consent to the circumscribed nature of your
              access and use while retrieving, retrieving, or browsing
              FameWheels website. The use of the website, browsing, accessing
              the platform, or utilizing any services is exclusively voluntary
              and under your decision and responsibility.
              <br /> <br />
              By agreeing to these terms, you acknowledge any risk that may
              associated with the utilization of any information provided on the
              FameWheels website. You are highly advised to thoroughly inquire
              and utilize the information available on the FameWheels website
              thoughtfully.
              <br /> <br />
              In some circumstances, we may announce specific terms amended to
              any specific content, which will be referred to as the “Additional
              Term”, which will be an appendage to the basic terms of use.
              Furthermore, the use of Mobile Applications can need to adhere to
              additional third-party terms or those are set app store. It is
              suggested to read carefully before downloading and installing the
              Mobile Application. The general Terms of Use incorporate these
              Additional Terms by reference.
            </p>
            <br />
            <h5>Right of terminate/suspend/discontinue of any service:</h5>
            <p>
              We hold the right to make modifications, discontinue, suspend, or
              cancel any services at any time without informing you. FameWheels
              is the sole owner to make the amendments in the information given
              on the any online platform without any notification. You also give
              an agreement that we shall not be liable for you or any third
              party for any modification, suspension or discontinuance of the
              website.
              <br /> <br />
              The FameWheels site holder has reservation of declaring
              terminations associated with service agreements and not disclosing
              any notice to the user and providing no reason. When there is a
              termination of the contract, the consumer is obliged to resolve
              all invoices within at most 10 working days.
            </p>
            <br />
            <h5>User Responsibilities and Limitations:</h5>
            <p>
              Subject to compliance with all pertinent laws, regulations, and
              the terms outlined in this agreement, you acknowledge, agree, and
              commit to abiding by this agreement (including the Terms of Use)
              as well as the following binding principles: Subject to compliance
              with all pertinent laws, regulations, and the terms outlined in
              this agreement, you acknowledge, agree, and commit to abiding by
              this agreement (including the Terms of Use) as well as the
              following binding principles:
              <br /> <br />
              Access and Usage Restrictions: You shall utilize the platform
              outright and use the services solely through the interfaces
              provided by FameWheels. You must not host, display, upload,
              modify, publish, transmit, update, or share any information,
              content, or user content that:You must not host, display, upload,
              modify, publish, transmit, update, or share any information,
              content, or user content that:
              <br />
              <br />
              <ul>
                <li>
                  Is a substance that the person does not have with him/her
                  lawfully.
                </li>
                <li>
                  A community standard is written such that any content that
                  includes abuses, harasses, defames, is obscene, pornographic,
                  or else may offend cannot be posted.
                </li>
                <li>Protecting minors from detriment in any way.</li>
                <li>
                  Seeks to act disruptively and devastatingly, breaking up,
                  bringing down, or otherwise countering the services provided
                  by the Website.
                </li>
                <li>
                  <b>Copyright and Proprietary Rights:</b> Do not reproduce
                  content of works with an attached copyright or do not infringe
                  on patents, trademarks, or other intellectual property rights.
                </li>
                <li>
                  <b>Legal Compliance:</b> You promise to abide by any laws,
                  rules, and code of conduct either within or outside the nation
                  of Pakistan.
                </li>
                <li>
                  <b>Malicious Content:</b> You do not share a placing a
                  software virus or any code designed to disrupt or injure a
                  computer system.
                </li>
                <li>
                  <b>Restricted Transactions:</b> You shall not participate in
                  any trade of goods which are considered as assets subject to
                  limitations, cancelation or restriction under applicable laws,
                  regulations, rules or directives.
                </li>
                <li>
                  <b>Unauthorized Access:</b> You will treat the FameWheels'
                  resourcses (accounts, systems, networks, and computer
                  resources) fairly and you will not be avaricious in doing so.
                  Without our consent, you will neither attempt to access other
                  accounts nor their resources.
                </li>
                <li>
                  <b>Unlawful Means:</b> Recollect that you are not to use the
                  website and its features through hacking, password mining or
                  other unfair automated means.
                </li>
                <li>
                  <b>Prohibited Activities:</b> You will use the Website for
                  lawful and legitimate purposes only, not involve in any
                  unlawful or illegal activities, and not request anybody to
                  commit illegal acts.
                </li>
                <li>
                  <b>Code of Conduct:</b> You will comply with any code of
                  conduct, guidelines or specifically applicable terms for using
                  certain online services.
                </li>
                <li>
                  <b>Reputation Preservation:</b> freedom to issue negative,
                  inappropriate, or unpleasant statements concerning FameWheels
                  and to engage in the activity which can harm the company's
                  reputation is not tolerated during the course of our mutual
                  work.
                </li>
                <li>
                  <b>Offensive Conduct:</b> You are not permitted to use the
                  Websites and services in an abusive or offensive manner, nor
                  are you permitted to upload any materials that is illegal or
                  socially unacceptable.
                </li>
                <li>
                  <b>Communication Consent:</b> By using the Website, you
                  consent to receive notices and other communications, through
                  such means as email and calls, pertaining to products or
                  services offered on the Website.
                </li>
              </ul>
              Should any of the herein-contained provisions be violated, it
              becomes our company's full right to either restrict or terminate
              your access to the Website and/or the services and even to follow
              up with additional remedies, under the circumstances.
            </p>
            <br />
            <h5>User Violations and Consequences:</h5>
            <p>
              That you agree that we (FameWheels) hold the right to either
              terminate or suspend your membership on the site if your
              listings/postings/comments or any other information does not
              comply with our listing policy or you breach any provision of this
              Agreement. In addition, we reserve the power to deny you or any
              espouses of yours access to the website.
              <br /> <br />
              This particular action shown here in reaction to any such alleged
              infringement of these term may also act as an additional measure
              to ensure the security and proper functioning of our website.
            </p>
            <br />
          </div>
        </div>
      </div>
    </>
  );
}
